import App from './App.vue';
import store from './store';
import Vue from 'vue';

export default (options) => {
    // все опции доступны везде как this.$appOptions (просто options зарезервировано)
    Vue.prototype.$appOptions = options;

    new Vue({
        store,
        render: (h) => {
            return h(App);
        }
    }).$mount(options.id);
};
